<template>
<section id="ForgotPassword">
    <div class="card wmin-sm-400">
        <div class="card-body">
            <div class="text-center mb-3">
                <img alt="" :src="$storeIndex.getImageGobalAssets('authorization/logo go_ship_02')">
            </div>
            <div class="text-center mb-3">
                <h3>{{$t('Reset Password Complete')}}</h3>
                <p class="text-muted"><b>{{ email }} </b>{{ $t('can now use')}}</p>
                <p class="text-muted">{{$t('new password to sign in to your account.')}}</p>
            </div>
            <div class="form-group">
                <ladda text="Sign in"  :btnClass="'btn btn-primary btn-block'" @click="goSuccessPassword()"></ladda>
            </div>
        </div>
    </div>
</section>
</template>
<script>
import Ladda from '@/plugins/Ladda.vue'
export default {
    components: {
        Ladda
    },
    data() {
        return {
            email: ''
        };
    },
    validationConfig: {
        $lazy: true,
    },
    validations: {

    },
    methods: {
        async goSuccessPassword() {
            this.$router.push({name:'auth.login'});
        },
    },
    mounted() {
        this.email = this.$route.params.email;
    }
};
</script>




// WEBPACK FOOTER //
// src/components/central/authorization/SuccessPassword.vue